import React from "react";
import { Languages, Sparkles } from "lucide-react";
import { Tx } from "../context/AutoTranslateContext";

/** Prominent, reassuring notice shown BEFORE booking (home, tutor lists,
 *  tutor profiles) telling students that Live AI Real-Time Translation
 *  (voice + text) removes every language barrier — even with Arabic-only tutors. */
const TranslationNotice = ({ variant = "banner", className = "" }) => {
  if (variant === "badge") {
    return (
      <span
        data-testid="ai-translation-badge"
        className={`inline-flex items-center gap-1.5 bg-gold/15 text-forest border border-gold/40 rounded-full px-3 py-1 text-[11px] font-medium ${className}`}
      >
        <Sparkles className="w-3 h-3 text-gold" />
        <Tx>Live AI translation in every session</Tx>
      </span>
    );
  }
  return (
    <div
      data-testid="ai-translation-notice"
      className={`flex items-start gap-3 rounded-2xl bg-forest text-sand p-4 sm:p-5 ${className}`}
    >
      <div className="w-10 h-10 rounded-full bg-gold/25 text-gold flex items-center justify-center flex-shrink-0">
        <Languages className="w-5 h-5" />
      </div>
      <div className="min-w-0">
        <p className="text-sm font-semibold mb-0.5 flex items-center gap-2 flex-wrap">
          <Tx>Language barrier? Completely solved.</Tx>
          <span className="text-[10px] uppercase tracking-widest bg-gold/25 text-gold px-2 py-0.5 rounded-full">
            <Tx>Live AI · Voice & Text</Tx>
          </span>
        </p>
        <p className="text-xs text-sand/80 leading-relaxed">
          <Tx>Every live session includes AI real-time translation — speech-to-text, translated captions and voice. Even if your tutor speaks only Arabic, you'll understand each other perfectly.</Tx>
        </p>
      </div>
    </div>
  );
};

export default TranslationNotice;
